import React from 'react';
import {connect, useSelector} from 'react-redux';

import './AddNewFund.scss';

import NewFundSearch from '../NewFundSearch/NewFundSearch';
import {getSalesforceRep} from "../../../../redux/modules/applicationConfig/applicationConfig.selectors";
import {getAddFundList} from "../../../../redux/modules/shoppingCart/shoppingCart.selectors";

export const AddNewFund = (
  customerWebViewEnabled,
  dispatchPageLoad,
  actions,
  IRALimit,
  addFunds,
  onClose,
  modalProps,
  shoppingCart,
) => {

  const exchangeToNewLoading = false;
  const userRegistrationTypeInfo = {
    selectedRegistrationType: {
      agreementType: '',
      formattedEntityNames: '',
      productType: 'MUTUAL_FUND'
    }
  };
  const isSalesforceRep = useSelector((state) => getSalesforceRep(state));
  const availableFundList = useSelector(getAddFundList);
  return (
        <NewFundSearch
          dispatchPageLoad={dispatchPageLoad}
          shoppingCart={shoppingCart}
          addFunds={addFunds}
          actions={actions}
          availableFundList={availableFundList}
          exchangeToNewLoading={exchangeToNewLoading}
          modalProps={modalProps}
          onClose={onClose}
          setFundProgress={'REGISTRATION'}
          userRegistrationTypeInfo={userRegistrationTypeInfo}
        />
  );
};

export default AddNewFund;
